







































































































































































































































import {Vue, Component} from 'vue-property-decorator';
import {DutyCategory, DutyInfo, DutyCategoriesTemplate, DutyContent} from 'supporter';
import DateCalendar from '@/components/common/datepicker/DateCalendar.vue';

@Component({components: {DateCalendar}})
export default class ProductDutyAddForm extends Vue {
  private isFirst = true;
  private nullModel = '';
  private error: any = {};
  private productDuty: any = {
    dutyContent: {
      contents: [],
      categoryNo: 0,
      categoryName: ''
    },
    saveFlag: 'N',
    saveTitle: ''
  };

  private callback = '';
  private displayProductDutys = false;
  private allProductDuties: DutyCategoriesTemplate[] = [];
  private products: number[] = [];
  private productDutyCategories: DutyCategory[] = [];
  private allInput = false;
  private maxSaveTitle = 100;
  private dutyDescription = '';
  created() {
    this.$api.getDutyCategories().then(ret => {
      this.productDutyCategories = ret.data;

      // modify&view
      if (this.$route.query.hasOwnProperty('mallProductNo')) {
        if (!this.$route.query.mallProductsCnt || Number(this.$route.query.mallProductsCnt) === 1) {
          const productNo = Number(this.$route.query.mallProductNo);
          this.products.push(productNo);
          const params = {
            productNo: String(productNo)
          };
          this.$api.getProductDuty({params}).then(ret => {
            this.setProductDuty({saveTitle: '', dutyContent: ret.data});
          });
        } else {
          const products = this.$route.query.mallProductNo;
          (products as string[]).forEach((productNo: string) => {
            this.products.push(Number(productNo));
          });
        }
      }
      // add  변경
      if (this.$route.query.hasOwnProperty('data')) {
        this.setProductDuty(JSON.parse(localStorage.getItem('data')));
      }
    });

    if (this.$route.query.hasOwnProperty('dataCallback')) {
      this.callback = this.$route.query.dataCallback as string;
    }
    this.fetchProductDutys();
  }
  private save() {
    const contents = this.productDuty.dutyContent.contents;
    // reset error.
    for(let contentName in this.error) {
         this.error[contentName] = false;
    }
    for (let i = 0; i < contents.length; i++) {
      if (!contents[i].model) {
        this.error[contents[i].contentName] = true;
        this.$forceUpdate();
        if (contents[i].modelType !== 'CALENDAR') {
          const ref = contents[i].displayOrder + '_ref';
          (this.$refs[ref] as any)[0].focus();
        }

        return;
      } else {
        this.error[contents[i].contentName] = false;
      }
    }

    const dutyInfo = this.getDutyInfo();
    const productsLength = this.products.length;
    // 저장
    if (productsLength === 1) {
      const params = {mallProductNo: String(this.products[0])};
      const data = {
        dutyInfo
      };
      this.$api.patchProductDuty({params, data}).then(() => {
        window.close();
      });
    } else if (productsLength > 1) {
      const params = {mallProductNos: this.products.toString()};
      const data = {
        dutyInfo
      };
      this.$api.patchProductsDuty({params, data}).then(() => {
        window.close();
      });
    } else {
      $(window.opener.location).attr('href', `javascript:window.${this.callback}(${JSON.stringify(dutyInfo)});`);
      window.close();
    }
  }
  changeModelType(index: number, e: Event) {
    const value = (e.target as HTMLInputElement).value;
    this.productDuty.dutyContent.contents[index].modelType = value;
    if (value === 'INPUT') {
      if (this.productDuty.dutyContent.contents[index].model) {
        this.nullModel = this.productDuty.dutyContent.contents[index].model;
      }
      this.productDuty.dutyContent.contents[index].model = '';
    } else if (value === 'CALENDAR') {
      if (this.nullModel) {
        this.productDuty.dutyContent.contents[index].model = this.nullModel;
        this.nullModel= '';
      }else {
        this.productDuty.dutyContent.contents[index].model = '';
      }
      // clear checkAll
      let chkAll = this.$refs.checkAll as HTMLInputElement;
      if (chkAll.checked) {
        chkAll.checked = false;
      }
    }
    this.$forceUpdate();
  }
  getDutyInfo() {
    const productDuty: any = {
      saveTitle: this.productDuty.saveFlag === 'Y' ? this.productDuty.saveTitle : undefined,
      dutyContent: {
        contents: [],
        categoryNo: this.productDuty.dutyContent.categoryNo,
        categoryName: this.productDuty.dutyContent.categoryName
      }
    };
    this.productDuty.dutyContent.contents.forEach((content: any) => {
      productDuty.dutyContent.contents.push({[content.contentName]: content.model});
    });

    return productDuty;
  }
  private changedAllInput(e: Event) {
    const checked = (e.target as HTMLInputElement).checked;
    let model = '';
    if (checked) {
      model = window.$t('PRODUCT_DUTY_DETAIL_REFERENCE');
    }
    this.productDuty.dutyContent.contents = this.productDuty.dutyContent.contents.map((content: any) => {
      if (content.dataType === 'date') {
        if (content.modelType === 'CALENDAR') {
          this.nullModel = content.model;
        }
        content.modelType = 'INPUT';
      }
      content.model = model;
      return content;
    });
  }
  private fetchProductDutys() {
    if (this.$route.name !== 'readForm') {
      this.$api.getDutyCategoriesTemplates().then(ret => {
        this.totalPage = ret.data.length ? Math.ceil(ret.data.length / this.pageSize) : 1
        this.allProductDuties = ret.data;
      });
    }
  }
  private totalPage = 1
  private page = 1
  private pageSize = 10
  private visablePageButtonSize = 10
  get firstPage(){
    return this.page - 5 > 0 ? this.page - 5 : 1
  }
  get lastPage(){
    const lastPage =  this.page - 5 > 0 ? this.page + 4 : this.visablePageButtonSize
    return lastPage <= this.totalPage ? lastPage : this.totalPage
  }
  get productDuties (){
    const start = this.page === 1 ? 0 : (this.page-1) * this.pageSize -1;
    const end = this.page === 1 ? this.page * this.pageSize : this.page * this.pageSize -1;
    return this.allProductDuties.slice(start,end)
  }
  changePage(page:number){
    this.page = page
  }
  private setProductDuty(productDuty: DutyCategoriesTemplate | DutyInfo) {
    if (this.$route.query.hasOwnProperty('data') || this.products.length === 1) {
      const productDutyInfo = productDuty as DutyInfo & { willDutyContent?: DutyContent };
      if (productDutyInfo.saveTitle) {
        this.productDuty.saveFlag = 'Y';
        this.productDuty.saveTitle = productDutyInfo.saveTitle;
      }
      const dutyContent = productDutyInfo.willDutyContent ? { ...productDutyInfo.willDutyContent as DutyContent } : { ...productDutyInfo.dutyContent };
      this.productDuty.dutyContent.categoryNo = dutyContent.categoryNo;
      this.setContents(dutyContent.contents);
      this.displayProductDutys = false;
    } else {
      const productDutyInfo = productDuty as DutyCategoriesTemplate;
      if (productDutyInfo.title) {
        this.productDuty.saveFlag = 'N';
        this.productDuty.saveTitle = '';
      }
      this.productDuty.dutyContent.categoryNo = productDutyInfo.dutyContent.categoryNo;
      this.productDuty.dutyContent.categoryName = productDutyInfo.dutyContent.categoryName;
      this.setContents(productDutyInfo.dutyContent.contents);
  
      this.displayProductDutys = false;
    }
  }
  private deleteProductDuty(productDuty: DutyCategoriesTemplate) {
    this.$api.deleteDutyCategoriesTemplates({params: {no: productDuty.no}}).then(() => {
      this.fetchProductDutys();
    });
  }
  setContents(contents?: any[]) {
    if (this.isFirst || confirm(window.$t('PRODUCT_DUTY_NO_SAVED_SURE'))) {
      this.allInput = false
      const dutyCategory = this.productDutyCategories.find(duty => {
        return duty.dutyCategoryNo === this.productDuty.dutyContent.categoryNo;
      }) as DutyCategory;
      this.productDuty.dutyContent.categoryName = dutyCategory.dutyCategoryName;
      
      this.dutyDescription = (dutyCategory as any).dutyCategoryDescription;
      const dutyCategoryContents = dutyCategory.dutyCategoryContents;
      this.productDuty.dutyContent.contents = dutyCategoryContents.map((content: any) => {
        //if (content.dataType === 'date') {
        //  content.modelType = 'CALENDAR';
        //}
        if (contents) {
          content.modelType = 'INPUT';
          content.model = this.getContentValue(content.contentName, contents);
        } else {
          content.model = '';
        }
        this.setModelType(content);
        return content;
      });
      if (this.isFirst) {
        this.isFirst = false;
      }
    }
  }
  getCalendarOption(displayOrder: number) {
    return {
      dateType: 'Ymd',
      havePeriodBtn: false,
      name: `calendar${displayOrder}`,
      onOpen: this.setStyle,
      onClose: this.resetStyle
    };
  }
  setStyle() {
    (document as any).querySelector('#dutyInfoForm').style = 'height: 870px;';
  }
  resetStyle() {
    (document as any).querySelector('#dutyInfoForm').style = 'height: 670px;';
  }
  getContentValue(contentName: string, contents: any[]): string {
    let contentNameValue = '';
    let content: any = null;
    for (let i = 0; i < contents.length; i++) {
      if (contents[i].hasOwnProperty(contentName)) {
        content = contents[i];
        contentNameValue = content[contentName];
        return contentNameValue;
      }
    }
    return contentNameValue;
  }
  setModelType(content: any): void {
     if (content.dataType === 'date') {
          let value = content.model;
          if (value) {
            let splitValue = value.split('-');
            let isDate = false;
            if (splitValue.length == 3) {
              let year = parseInt(splitValue[0]);
              let month = parseInt(splitValue[1]) - 1;
              let day = parseInt(splitValue[2]);
              if ((year >= 1500 && year <= 2999) && (month >= 0 && month <= 11) && (day >= 1 && day <= 31)) {
                  isDate = true;
              }
            }
            if(isDate) {
              // when content.model is string of date
              content.modelType = 'CALENDAR';
            }else {
              content.modelType = 'INPUT';
            }
          } else {
              //when content.model is empty
              content.modelType = 'CALENDAR';
          }
         
      }
  }
  

}
